import type { FC, ReactNode } from 'react';
import { Form } from 'antd';
import classNames from 'classnames';
import styles from './preset-form.module.scss';

interface PresetFormItemProps {
  label: ReactNode;
  description?: ReactNode;
  error?: string;
  required?: boolean;
  fullWidth?: boolean;
  children: ReactNode;
}

export const PresetFormItem: FC<PresetFormItemProps> = ({
  label,
  description,
  error,
  required = false,
  fullWidth = false,
  children,
}) => (
  <Form.Item
    label={label}
    required={required}
    validateStatus={error ? 'error' : undefined}
    help={error}
    extra={description}
    className={classNames(styles.formItem, {
      [styles.optionalFormItem]: !required,
      [styles.fullWidth]: fullWidth,
    })}
  >
    {children}
  </Form.Item>
);
